import { useState } from "react";
import logo from "../images/logo.png";

const links = [
  { label: "About Me", href: "#about" },
  { label: "How I Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "FAQs", href: "#faqs" },
  { label: "Contact", href: "#contact" },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-sm bg-[#faf7f3]/80 border-b border-[rgba(217,162,153,0.2)]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="flex items-center justify-between h-[68px]">
          <a href="#about">
            <img src={logo} alt="Nymfodora Giannakidou" className="h-[52px] w-auto" />
          </a>

          {/* Desktop */}
          <ul className="hidden md:flex items-center gap-1 list-none m-0 p-0">
            {links.map(({ label, href }) => (
              <li key={label}>
                <a
                  href={href}
                  className="px-3 py-2 block text-[0.85rem] text-[#5a5a5a] hover:text-[#3a3a3a] transition-colors no-underline"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>

          {/* Mobile hamburger */}
          <button
            className="md:hidden bg-transparent border-0 p-2 cursor-pointer flex flex-col gap-[5px]"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
          >
            <span className="block w-5 h-[1.5px] bg-[#3a3a3a]" />
            <span className="block w-5 h-[1.5px] bg-[#3a3a3a]" />
            <span className="block w-5 h-[1.5px] bg-[#3a3a3a]" />
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <ul className="md:hidden flex flex-col list-none m-0 p-0 pb-4 border-t border-[rgba(217,162,153,0.2)] pt-2">
            {links.map(({ label, href }) => (
              <li key={label}>
                <a
                  href={href}
                  className="py-3 block text-[0.9rem] text-[#5a5a5a] hover:text-[#3a3a3a] transition-colors no-underline border-b border-[#ede5e0]"
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
